import vinod from './vinod.png'
import RalphCiancioHomes from './RalphCiancioHomes.png'
import LinoArci from './LinoArci.png'
import RightAtHomeRealty from './RightAtHomeRealty.png'
import HomeLifeNewWorldRealty from './HomeLifeNewWorldRealty.png'
import REMAXWestRealty from './REMAXWestRealty.png'
import SuttonGroup from './SuttonGroup.png'
import KennectRealty from './KennectRealty.png'
import RealtySpecialists from './RealtySpecialists.png'
import RoyalLepage  from './RoyalLepage .png'


export const RealtorData = [
    {img: RalphCiancioHomes, 
    name: "Ralph Ciancio Homes",
    about: "Ralph is first and foremost committed to his clients and serving their real estate needs. In fact, more than 90% of his business comes from client referrals. It’s his passion for helping people that really sets him apart from other Realtors.",
    location: "190 MAIN ST UNIT 201, Markham, Ontario, L3R2G9",
    number: "647 247 6000",
    },
    {img: vinod , 
    name: "Vinod Maun, Realtor",
    about: "Welcome to our real estate business! Our team of experienced realtors is committed to providing exceptional service to help you achieve your real estate goals. With our local market expertise, personalized guidance, and professionalism, we aim to exceed your expectations.",
    location: "503-55 City Centre Dr., Mississauga, Ontario, L5B 1M3",
    number: "647-291-2373",
    },
    {img: LinoArci , 
    name: "RE/MAX Hallmark Lino Arci Group Realty",
    about: "Commitment, confidence and caring are the qualities that have made Lino Arci one of the top real estate agents in the Greater Toronto Area for over 35 years. A dynamic and dedicated professional, Lino is satisfied with nothing less than the best for every client.",
    location: "3420 Major MacKenzie Dr W, Unit 103, Vaughan, Ontario, L4H 4J6",
    number: "(416) 571-2724",
    },
    {img: RightAtHomeRealty , 
    name: "Right At Home Realty Inc.",
    about: "Jim Gallagher lives and breathes everything the GTA has to offer. Jim offers a LOW Total Commission Package that includes FREE Home Staging & Professional Photo's on all his listings. Full market exposure including both regional and international website marketing plus all the expected social media exposure",
    location: "1 Yonge Street, Suite 1801 Toronto, ON M5E 1W7",
    number: "416-219-9400",
    },
    {img: HomeLifeNewWorldRealty , 
    name: "HomeLife New World Realty Inc",
    about: "Top 5% Sales Representative in Canada (GSC). 2014 - 2022 Top Producer and Highest Achievements Award Winner! My promise is to make every client happy. If I don't currently have any listings that interest you, let me help you find other properties that do",
    location: "201 Consumers Rd., Suite 205, Toronto, Ontario, M2J4G8",
    number: "416-490-1177",
    },
    {img: REMAXWestRealty , 
    name: "RE/MAX West Realty Inc.",
    about: "My passion for real estate stems from my love for working with people and helping them live a better lifestyle. I always put my clients’ interests first and ensure my availability for them whenever needed. I focus on making the buying or selling process easier for them. My clients have always admired me for my honesty, reliability and unsurpassed patience while negotiating deals.",
    location: "96 Rexdale Blvd, Toronto ON, Toronto, Ontario, M9W1N7",
    number: "647-287-7653",
    },
    {img: SuttonGroup , 
    name: "Sutton Group - Admiral Realty Inc.",
    about: "Dave has a passion for helping his community – a passion that has driven him to remarkable success as a top Vaughan Realtor®. His team of specialized real estate agents (Team Elfassy) has set the bar for value, service and results. Clients and neighbours in Thornhill, Richmond Hill, Aurora, Markham and Toronto have all benefited from their experience and expertise.",
    location: "1206 Centre Street, Toronto, Ontario, L4J 3M9",
    number: "4168991199",
    },
    {img: KennectRealty , 
    name: "Century 21 Kennect Realty",
    about: "Arun Ganguly Specializes in Residential, Multifamily and investment real estate including family homes and industrial and commercial units in Toronto, Whitby, Ajax, Oshawa, Brampton, Caledon, Bolton, Mississauga, Scarborough, Georgetown, Malton, Vaughan, Etobicoke, Woodbridge, London, Kitchener - Waterloo and surrounding areas.",
    location: "11160 YONGE ST # 3 & 7, Toronto, Ontario",
    number: "905-883-8300",
    },
    {img: RealtySpecialists , 
    name: "RE/MAX Realty Specialists Inc.",
    about: "Gyanesh Paliwal is a full time REALTOR with ReMax Realty Specialists inc., Brokerage. Gyanesh has been the Sales Leader many a times at his brokerage's head office in Millcreek, Mississauga amongst around 120 Real Estate agents. He also works very closely with a few Top builders across the GTA selling pre-construction homes and condominiums.",
    location: "#200 - 4310 Sherwoodtowne Blvd, Mississauga, Ontario, L4Z 4C4",
    number: "905-272-3434",
    },
    {img: RoyalLepage , 
    name: "Royal Lepage Real Estate Services Ltd.",
    about: "I am an enthusiastic and hard-working REALTOR®, dedicated to partnering with my clients to achieve the ultimate goal of uniting your family with the ultimate home! I love it here I have great pride and commitment to the community and I would LOVE to share that commitment with you",
    location: "251 North Service Road West, Oakville, Ontario, L6M 3E7",
    number: "905-338-3737",
    }
]